import { useRef, useState } from "react";
import { api, API } from "../lib/api";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";

export default function ImageUploader({ value, onChange, testid = "image-uploader", label = "Upload image", kind = "image" }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const isVideo = kind === "video";
  const maxMB = isVideo ? 100 : 10;
  const accept = isVideo
    ? "video/mp4,video/quicktime,video/webm,video/x-m4v"
    : "image/png,image/jpeg,image/webp,image/gif";

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > maxMB * 1024 * 1024) { toast.error(`Max ${maxMB} MB`); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      // data.url is "/api/files/{id}" — strip the "/api" prefix because API already has it
      const path = data.url.startsWith("/api") ? data.url.slice(4) : data.url;
      const fullUrl = `${API}${path}`;
      onChange(fullUrl);
      toast.success("Uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };

  if (value) {
    return (
      <div className="relative inline-block" data-testid={`${testid}-preview`}>
        {isVideo ? (
          <video src={value} controls className="max-h-48 max-w-full border border-secondary/20 rounded-sm" />
        ) : (
          <img src={value} alt="" className="max-h-48 max-w-full border border-secondary/20 rounded-sm" />
        )}
        <button type="button" onClick={() => onChange("")} className="absolute top-1 right-1 w-7 h-7 bg-black/70 border border-secondary/40 rounded-sm flex items-center justify-center text-foreground hover:bg-black" data-testid={`${testid}-remove`}>
          <X size={14} strokeWidth={1.5} />
        </button>
      </div>
    );
  }

  return (
    <label className={`inline-flex items-center gap-2 px-4 py-2 border border-secondary/30 rounded-sm cursor-pointer hover:bg-secondary/5 text-sm uppercase tracking-wider ${busy ? "opacity-60" : ""}`} data-testid={`${testid}-btn`}>
      <Upload size={14} strokeWidth={1.25} />
      {busy ? "Uploading..." : label}
      <input ref={ref} type="file" accept={accept} onChange={onFile} className="hidden" disabled={busy} data-testid={`${testid}-input`} />
    </label>
  );
}
